// extracted by mini-css-extract-plugin
export default {"background":"LightBox_background__zGs40","close":"LightBox_close__ESZaG","box":"LightBox_box__0EtTu","content":"LightBox_content__qp3JX"};